import validateRules from './validate-rules';
import {removeErrorField, renderError} from './field-error';

function validateTypeField(field) {
	if (field.value === null || field.type === undefined) {
		return;
	}

	if (field.type === 'checkbox' && field.getAttribute('required') !== null) {
		return field.checked ? undefined : 'This field is required';
	}

	const rule = validateRules[field.type];

	if (rule !== undefined) {
		return rule.regExpression.test(field.value) ? undefined : rule.errorText;
	}

	return undefined;
}

function validateRequiredField(field) {
	let isValid = true;

	if (field.getAttribute('required') !== null && field.classList.contains('form__radio-buttons-group')) {
		const radioButtons = field.querySelectorAll('.radio-button');

		isValid = false;

		let i = 0;

		while (!isValid && i <= radioButtons.length) {
			if (radioButtons[i] && radioButtons[i].checked) isValid = true;
			i += 1;
		}

		return isValid ? undefined : 'This field is required';
	}

	if (field.getAttribute('required') !== null && field.classList.contains('form__multi-select')) {
		const selectedOptions = field.querySelectorAll('.selectr-tag');

		return selectedOptions.length ? undefined : 'This field is required';
	}

	if (field.getAttribute('required') !== null) {
		switch (field.type) {
			case 'checkbox':
				isValid = field.checked;
				break;
			default:
				isValid = field.value.length > 0;
		}
	}

	return isValid ? undefined : 'This field is required';
}

export function fieldValidate(field) {
	removeErrorField(field);
	if (field.classList.contains('form__input__login')) return;
	let errorText;

	if (field.value && field.value.length) {
		errorText = validateTypeField(field);
	} else {
		errorText = validateRequiredField(field);
	}

	const equallyFieldName = field.getAttribute('data-equally-field-name');

	if (equallyFieldName !== null) {
		const fieldEquall = document.querySelector(`[name="${equallyFieldName}"]`);

		if (fieldEquall.value !== field.value) {
			errorText = `This field should be equal to field ${equallyFieldName}`;
		}
	}

	const dateType = field.getAttribute('id');

	if (dateType !== null) {
		if (dateType === 'closing') {
			const closingDate = document.getElementById(dateType);
			const interviewDate = document.getElementById('interview');

			if (interviewDate !== null && interviewDate.value !== '') {
				if (new Date(closingDate.value) > new Date(interviewDate.value)) {
					errorText = 'Please select another interview date. Interview date can not be before closing date';
				} else {
					removeErrorField(closingDate);
					removeErrorField(interviewDate);
				}
			}
		}
		if (dateType === 'interview') {
			const interviewDate = document.getElementById(dateType);
			const closingDate = document.getElementById('closing');

			if (interviewDate.value !== '') {
				if (closingDate !== null && closingDate.value !== '') {
					if (new Date(closingDate.value) > new Date(interviewDate.value)) {
						errorText = 'Please select another closing date. Interview date can not be before closing date';
					} else {
						removeErrorField(closingDate);
						removeErrorField(interviewDate);
					}
				}
			} else {
				removeErrorField(closingDate);
				removeErrorField(interviewDate);
			}
		}
	}
	if (errorText !== undefined) {
		renderError(field, errorText);
	}
}

export function valdateCaptcha(form) {
	const captcha = form.querySelector('.g-recaptcha');

	if (captcha !== null) {
		const captchaResponce = captcha.querySelector('.g-recaptcha-response');

		if (captchaResponce.value.length) {
			removeErrorField(captcha);
		} else {
			renderError(captcha, 'Captcha is not valid');
		}
	}
}
